export enum EGender {
    male = 0,
    femail = 1,
    notSet = 2
}